module.exports = __webpack_public_path__ + "static/media/twitter.0f9571bd.svg";